import { Injectable, EventEmitter } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Gerenciamento AC',
        'Sistema de gestão de ARs',
        {
            needReloadMenu: new EventEmitter<boolean>(),
            needReloadDashboard: new EventEmitter<boolean>(),
            needReloadLoader: new EventEmitter<boolean>(),
            steps: new EventEmitter<boolean>()
        },
        {
            saveFilterInSession: true,
            defaultQuantityByPage: 15
        },
        {
            menu: 'vertical', // horizontal , vertical
            menuType: 'default', // default, compact, mini
            showMenu: true,
            navbarIsFixed: true,
            footerIsFixed: false,
            sidebarIsFixed: true,
            showSideChat: false,
            sideChatIsHoverable: true,
            skin: 'greyLight'  // light , dark, blue, green, combined, purple, orange, brown, grey, pink
        },
        [],
        []
    );
}
